import axios from "axios";
import { convertArgMapListToQueryString, getCookie } from "../../utils";
import { API_BASE_PATH } from "../../const";


const getSubscriptions = (args) => {
    const paramsString = convertArgMapListToQueryString(args)
    return axios
        .get(API_BASE_PATH + `subscriptions/${paramsString}`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};


const getSubscriptionDetail = (args) => {
    
    return axios
        .get(API_BASE_PATH + `subscriptions/${args.subscriptionId}/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const updateSubscription = (subscriptionId, args) => {
    
    return axios
        .patch(API_BASE_PATH + `subscriptions/${subscriptionId}/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};



const setSubscriptionExpiry = (subscriptionId, args) => {
    return axios
        .post(API_BASE_PATH + `subscriptions/${subscriptionId}/set_expiry/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const cancelSubscription = (subscriptionId, args) => {
    return axios
        .post(API_BASE_PATH + `subscriptions/${subscriptionId}/cancel/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const restartSubscription = (subscriptionId, args) => {
     return axios
         .post(API_BASE_PATH + `subscriptions/${subscriptionId}/activate/`, {
                 ...args
             }, {
                 headers: {
                     'X-CSRFToken': getCookie("csrftoken"),
                 }
             })
             .then((response) => {
                 return response.data;
             });
 };


const getSubscriptionWebhooks = (subscriptionId, args) => {
     return axios
         .get(API_BASE_PATH + `subscriptions/${subscriptionId}/webhooks/`, {
                 headers: {
                     'X-CSRFToken': getCookie("csrftoken"),
                 }
             })
             .then((response) => {
                 return response.data;
             });
 };

 const getSubscriptionAuditLogs = (subscriptionId, args) => {
    return axios
        .get(API_BASE_PATH + `subscriptions/${subscriptionId}/audit_logs/`, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};


const subscriptionsService = {
    getSubscriptions,
    getSubscriptionDetail,
    updateSubscription,
    cancelSubscription,
    restartSubscription,
    setSubscriptionExpiry,
    getSubscriptionWebhooks,
    getSubscriptionAuditLogs
};

export default subscriptionsService;